import { isEqual, omitBy } from 'lodash-es';
import { Reducer } from 'redux';
import { StatisticsChannelsState, ChannelsActionTypes } from './types';

const defaultState = {
    loading: false,
    singleChannelLoading: false,
    activePage: 1,
    perPage: 10,
    search: '',
};

const reducer: Reducer<StatisticsChannelsState> = (state: StatisticsChannelsState = defaultState, action): StatisticsChannelsState => {
    const { payload, type } = action;
    switch (type) {
        case ChannelsActionTypes.LOAD_ALL:
            return {
                ...state,
                loading: true,
            };
        case ChannelsActionTypes.LOAD_ALL_ERROR:
            return {
                ...state,
                loading: false,
            };
        case ChannelsActionTypes.LOAD_ALL_SUCCESS:
            return {
                ...state,
                ...omitBy(payload, (v, i) => isEqual(state[i], v)),
                loading: false,
            };
        case ChannelsActionTypes.LOAD_SINGLECHANNEL_START:
        case ChannelsActionTypes.LOAD_SINGLECHANNEL_SUCCESS:
        case ChannelsActionTypes.LOAD_SINGLECHANNEL_ERROR:
            return { ...state, ...payload };
        case ChannelsActionTypes.CLEAR_CHANNELS: {
            return {
                ...state,
                channels: [],
            };
        }
        case ChannelsActionTypes.EXPORT_CHANNELS:
        case ChannelsActionTypes.EXPORT_CHANNELS_START:
        case ChannelsActionTypes.EXPORT_CHANNELS_ERROR:
        case ChannelsActionTypes.EXPORT_CHANNELS_SUCCESS:
        case ChannelsActionTypes.CLEAR_DATA:
            return defaultState;
        case ChannelsActionTypes.SEARCH_FOR_CHANNELS:
        default:
            return state;
    }
};

export { reducer as channels };

export default reducer;
